import { useState, type FC } from "react";
import BrandLogo from "../../components/BrandLogo";
import { Button } from "../../components/ui/button";
import { gluceraAssessmentCta } from "../../utils/gluceraTypography";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import SessionStorageHelper from "../../utils/sessionStorageHelper";

const Eatmealpage: FC = () => {
  const navigate = useNavigate();
  const [mealTimes, setMealTimes] = useState<string[]>(["", "", ""]);

  const handleMealTimeChange = (index: number, value: string) => {
    const newMealTimes = [...mealTimes];
    newMealTimes[index] = value;
    setMealTimes(newMealTimes);
  };

  const handleNext = () => {
    const filledTimes = mealTimes.filter(time => time && time.length > 0);

    SessionStorageHelper.saveMultipleFields({
      meal_times: filledTimes,
    });

    navigate("/glucera" + GluceraNavigationRoutes.IntermittentFastingPage);
  };

  const handleSkip = () => {
    SessionStorageHelper.saveMultipleFields({
      meal_times: [],
    });

    navigate("/glucera" + GluceraNavigationRoutes.IntermittentFastingPage);
  };

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header */}
        <div className="space-y-4 px-4 pb-4 pt-safe">
          <BrandLogo />

          {/* Assessment Progress */}
          <p className="text-center text-subhead text-muted-foreground">
            Assessment 10 of 12
          </p>
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col px-6 py-2">
          <div className="mb-8 space-y-2">
            <h1 className="text-large-title font-bold text-foreground sm:text-4xl">
              When Do You Usually Eat Your Meals?
            </h1>
            <p className="text-subhead text-muted-foreground">
              Setting your typical meal times helps better predict balance
              levels
            </p>
          </div>

          <div className="space-y-4">
            {["First Meal", "Second Meal", "Third Meal"].map((meal, idx) => (
              <div key={idx}>
                <Label className="mb-2 block text-callout text-foreground">{meal}</Label>
                <Input
                  type="time"
                  className="h-12"
                  value={mealTimes[idx] || ""}
                  onChange={e => handleMealTimeChange(idx, e.target.value)}
                />
              </div>
            ))}
            <p className="pt-2 text-center text-caption1 text-muted-foreground">
              Skip if your time is not fixed
            </p>
          </div>

          {/* Button Container */}
          <div className="mt-auto space-y-3 pt-4">
            <Button
              onClick={handleNext}
              className={gluceraAssessmentCta}
            >
              Next
            </Button>
            <button
              onClick={handleSkip}
              className="w-full text-center text-subhead text-muted-foreground underline transition-colors hover:text-foreground"
            >
              Skip if your time is not fixed
            </button>
          </div>
        </div>

        {/* Safe area padding */}
        <div className="pb-safe p-2" />
      </div>
    </div>
  );
};

export default Eatmealpage;
